module.exports = __webpack_public_path__ + "static/img/8.8c6fa2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/8.png
// module id = WTS/
// module chunks = 0